import SvgIcon from "../../../../../parts/SvgIcon";
const moment = require("moment");
const submit = require("submit-form");
const {
  getYearAndMonth,
  getSelectedWeek,
  defaultFormat,
} = require("../body-composition.helper");

const onControlClick = (
  selectedWeek,
  startDate,
  endDate,
  calendarDay,
  direction,
  numberOfDays
) => {
  const { year, month } = getYearAndMonth(startDate);
  const { weeksNumber } = getSelectedWeek(
    selectedWeek,
    year,
    month,
    calendarDay
  );

  const startDay =
    direction === "left"
      ? moment(startDate).subtract(numberOfDays, "days").format(defaultFormat)
      : moment(startDate).add(numberOfDays, "days").format(defaultFormat);

  const endDay =
    direction === "left"
      ? moment(endDate).subtract(numberOfDays, "days").format(defaultFormat)
      : moment(endDate).add(numberOfDays, "days").format(defaultFormat);

  submit("/actions/refresh?", {
    method: "GET",
    body: {
      "modal[type]": "",
      selectedWeek,
      startDay,
      endDay,
      weeksNumber,
    },
  });
};

const ControlButton = ({
  direction,
  selectedWeek,
  startDate,
  endDate,
  calendarDay,
}) => {
  return (
    <button
      data-button-type="secondary"
      data-icon-only
      onClick={() =>
        onControlClick(
          selectedWeek,
          startDate,
          endDate,
          calendarDay,
          direction,
          7
        )
      }
      id={`${selectedWeek}-multiple`}
    >
      <SvgIcon
        src={
          direction === "left"
            ? "/img/new-icons/double-arrow-left.svg"
            : "/img/new-icons/double-arrow-right.svg"
        }
      />
    </button>
  );
};

const WeekDisplay = ({ startDate, endDate, calendarDay, selectedWeek }) => {
  const left = "<";
  const right = ">";

  return (
    <div>
      <button
        data-button-type="text-white"
        data-icon-only
        onClick={() =>
          onControlClick(
            selectedWeek,
            startDate,
            endDate,
            calendarDay,
            "left",
            1
          )
        }
        id={`${selectedWeek}-single`}
      >
        <SvgIcon src="/img/new-icons/arrow-left.svg" />
      </button>
      <span className="composition-date-display">
        {moment(startDate).format("ddd DD")} -{" "}
        {moment(endDate).format("ddd DD")}
      </span>
      <button
        data-button-type="text-white"
        data-icon-only
        onClick={() =>
          onControlClick(
            selectedWeek,
            startDate,
            endDate,
            calendarDay,
            "right",
            1
          )
        }
        id={`${selectedWeek}-single`}
      >
        <SvgIcon src="/img/new-icons/arrow-right.svg" />
      </button>
    </div>
  );
};

//weeksNumber evaluation is very important because some month have 4 weeks and some have 5
//those month with 5 weeks instead of 4 are filling the remaning week with the next month dates
const getNextNumber = (number, weeksNumber) => {
  if (weeksNumber === 4 && number === 4) return 6;
  if (number === 5) return 6;
  return number + 1;
};

const getPrevNumber = (number) => {
  if (number === 1) return 7;
  return number - 1;
};

const WeekSelectionBar = ({
  daysOfWeek,
  selectedWeek,
  weeksNumber,
  startDate,
  endDate,
  calendarDay,
}) => {
  const intWeek = parseInt(selectedWeek, 10);

  return (
    <div role="month-handler">
      <ControlButton
        direction="left"
        selectedWeek={getPrevNumber(intWeek)}
        startDate={startDate}
        endDate={endDate}
        calendarDay={calendarDay}
      />
      <WeekDisplay
        daysOfWeek={daysOfWeek}
        startDate={startDate}
        endDate={endDate}
        selectedWeek={selectedWeek}
        calendarDay={calendarDay}
      />
      <ControlButton
        direction="right"
        selectedWeek={getNextNumber(intWeek, weeksNumber)}
        startDate={startDate}
        endDate={endDate}
        calendarDay={calendarDay}
      />
    </div>
  );
};

export default WeekSelectionBar;
